import { Entypo, Ionicons } from '@expo/vector-icons';
import { router } from 'expo-router';
import { StyleSheet, TouchableOpacity, ViewStyle } from 'react-native';

interface Props {
  onPress?: () => void;
  style?: ViewStyle;
  iconColor?: string;
  size?: number;
  hitSlop?: number;
  variant?: 'default' | 'alternative';
}

const NotificationButton = ({ onPress, style, iconColor, size, hitSlop = 30, variant = 'default' }: Props) => {
  return (
    <TouchableOpacity
      onPress={onPress !== undefined ? onPress : () => router.navigate('/messages')}
      style={style}
      hitSlop={{ top: hitSlop, bottom: hitSlop, left: hitSlop, right: hitSlop }}>
      {variant === 'default' && (
        <Ionicons
          name="chatbox-outline"
          size={size ?? 24}
          color={iconColor ? iconColor : '#808080'}
          style={styles.notificationIcon}
        />
      )}
      {variant === 'alternative' && (
        <Entypo
          name="message"
          size={size ?? 24}
          color={iconColor ? iconColor : '#808080'}
          style={styles.notificationIcon}
        />
      )}
    </TouchableOpacity>
  );
};
const styles = StyleSheet.create({
  notificationIcon: {
    transform: [{ scaleX: -1 }]
  }
});

export default NotificationButton;
